export default __webpack_public_path__ + "static/media/blush-hot-autumn.a7628556.png";